import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Dialog, Transition } from "@headlessui/react";
import MediaWrapper from "@/components/mediaWrapper";
import { XMarkIcon } from "@heroicons/react/24/solid";

function ImageViewerModal({ image, isOpen, setIsOpen }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[1000]"
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-background-primary bg-opacity-40 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center sm:p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="pointer-events-none relative flex h-full w-full items-center justify-center">
              <div className="pointer-events-auto max-h-full overflow-y-auto overflow-x-hidden sm:rounded-2xl sm:shadow-xl">
                <div className="absolute inset-x-0 top-0 z-10 flex items-center justify-end p-4 sm:p-6">
                  <button
                    type="button"
                    className="z-10 rounded-md  bg-background-primary/80 p-2 text-text-on-primary hover:bg-background-primary-light/80 hover:text-text-on-primary-light focus:outline-none focus:ring-2 focus:ring-ring-primary focus:ring-offset-2"
                    onClick={() => setIsOpen(false)}
                  >
                    <span className="sr-only">{"Close"}</span>
                    <XMarkIcon
                      className="h-12 w-12 sm:h-8 sm:w-8"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                <MediaWrapper
                  media={image}
                  divClassName="flex items-center justify-center h-full"
                  objectFit="contain"
                  controls
                />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

ImageViewerModal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.object,
};

export default ImageViewerModal;
